'use client'
import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom'; // Use react-router-dom for routing.
import eventsData from '../../data/eventsData.json';
import {
  fetchPublicEvents,
  getPublicEventCtaLabel,
  getPublicEventPath,
  mapApiEventToCard,
} from '../../services/publicEventsApi';
import { fetchHomeContent, mapScheduleItemsToCards } from '../../services/homeContentApi';

const ScheduleTwo = () => {
  const [events, setEvents] = useState([]);
  const [scheduleTitle, setScheduleTitle] = useState('Évènements à la une');

  useEffect(() => {
    const defs = eventsData?.categories || [];

    let cancelled = false;
    (async () => {
      try {
        const home = await fetchHomeContent();
        const mode = home?.schedule?.mode;
        const items = home?.schedule?.items || [];
        if (Array.isArray(items) && items.length > 0) {
          if (!cancelled) {
            setEvents(mapScheduleItemsToCards(items, defs));
            setScheduleTitle(
              mode === 'UPCOMING'
                ? 'Évènements les plus proches'
                : 'Évènements récents',
            );
          }
          return;
        }
        const { events: apiList } = await fetchPublicEvents({ limit: 3 });
        if (cancelled) return;
        setEvents(apiList.map((e) => mapApiEventToCard(e, defs)));
      } catch {
        if (!cancelled) setEvents([]);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <React.Fragment>
      {/* Service Details Start */}
      <section id="th-blog" className="body-bg-color-2 event-page">
        <div className="container">
          <div className="schedule-one__inner">
            <div className="section-title text-left">
              <div className="section-title__tagline-box">
                <span className="section-title__tagline">
                  évènements
                </span>
              </div>
              <h2 className="section-title__title section-title__title--two">
                {scheduleTitle}
              </h2>
            </div>
            <div className="schedule-two__main-tab-box tabs-box">
              <div className="tabs-content">
                  <div className="tab active-tab" id="featured-events">
                    <div className="schedule-one__tab-content-box">
                      {events.map((event) => (
                        <div key={event.id} className="schedule-one__single">
                          <div className="schedule-one__left">
                            <h3 className="schedule-two__title">
                              <Link to={getPublicEventPath(event)}>
                                {event.title}
                              </Link>
                            </h3>
                            <p className="schedule-two__text">
                              {event.description}
                            </p>
                          </div>
                          <div className="schedule-one__img">
                            <img src={(event.image)} alt={event.title} />
                          </div>
                          <div className="schedule-one__address-and-btn-box">
                            <ul className="list-unstyled schedule-two__address">
                              <li>
                                <div className="icon">
                                  <span className="icon-clock"></span>
                                </div>
                                <div className="text">
                                  <p>
                                    {event.time} <br /> {event.date}
                                  </p>
                                </div>
                              </li>
                              <li>
                                <div className="icon">
                                  <span className="icon-pin"></span>
                                </div>
                                <div className="text">
                                  <p>
                                    {event.location}
                                  </p>
                                </div>
                              </li>
                            </ul>
                            <div className="schedule-one__btn-box">
                              <Link to={getPublicEventPath(event)} className="schedule-one__btn thm-btn">
                                {event.ctaLabel || getPublicEventCtaLabel(event)}
                              </Link>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                <Link to="/events" className="schedule-two__btn">
                  Voir plus <span className="icon-arrow-right"></span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Service Details End */}
    </React.Fragment>
  );
};

export default ScheduleTwo;
